import React from 'react'
import ErrorMessage from '../ErrorMessage/ErrorMessage'
import { FormState, UseFormRegister } from 'react-hook-form'

export type Invoice3rdPartyConfirmFormValues = {
    invoiceName: string
    invoiceEmail: string
    invoiceAddress: string
    invoiceZipcode: string
    invoiceCity: string
}

interface Invoice3rdPartyFormProps {
    register: UseFormRegister<Invoice3rdPartyConfirmFormValues>
    formState: FormState<Invoice3rdPartyConfirmFormValues>
}

const Invoice3rdPartyConfirmForm: React.FunctionComponent<Invoice3rdPartyFormProps> = ({ register, formState }) => {
    return (
        <form className='flex flex-col space-y-4'>
            <div className='flex flex-col space-y-1'>
                <h2 className='font-medium text-lg mb-0'>Controleer en/of wijzig factuurgegevens</h2>
            </div>
            <div className='flex flex-col space-y-1'>
                <label htmlFor='invoiceName' className='text-sm font-medium text-[--tb-mainHeading] mb-1 block'>
                    (Bedrijfs)naam op factuur
                </label>
                <input
                    {...register('invoiceName', { required: 'Naam is verplicht' })}
                    placeholder='(Bedrijfs)naam op factuur'
                    autoComplete='billing family-name'
                    id='invoiceName'
                    type={'text'}
                    className='w-full'
                />
                <ErrorMessage
                    message={
                        typeof formState.errors.invoiceName?.message === 'string'
                            ? formState.errors.invoiceName?.message
                            : undefined
                    }
                />
            </div>

            <div className='flex flex-col space-y-1'>
                <label htmlFor='invoiceEmail' className='text-sm font-medium text-[--tb-mainHeading] mb-1 block'>
                    E-mailadres
                </label>
                <input
                    {...register('invoiceEmail', {
                        required: 'E-mailadres is verplicht',
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: 'Ongeldig e-mailadres'
                        },
                        disabled: true
                    })}
                    id='invoiceEmail'
                    placeholder='E-mailadres van de klant'
                    type={'email'}
                    className='w-full'
                />
                <ErrorMessage
                    message={
                        typeof formState.errors.invoiceEmail?.message === 'string'
                            ? formState.errors.invoiceEmail?.message
                            : undefined
                    }
                />
            </div>

            <div className='flex flex-col space-y-1'>
                <label htmlFor='invoiceAddress' className='text-sm font-medium text-[--tb-mainHeading] mb-1 block'>
                    Factuuradres
                </label>
                <input
                    {...register('invoiceAddress', { required: 'Straat is verplicht' })}
                    id='invoiceAddress'
                    placeholder='Voorbeeldlaan'
                    type={'text'}
                    className='mb-1'
                />
                <ErrorMessage
                    message={
                        typeof formState.errors.invoiceAddress?.message === 'string'
                            ? formState.errors.invoiceAddress?.message
                            : undefined
                    }
                />
            </div>

            <div className='flex flex-wrap md:flex-nowrap space-y-4 md:space-y-0 md:space-x-4 mb-1'>
                <div className='w-full flex-grow'>
                    <label htmlFor='invoiceZipcode' className='text-sm font-medium text-[--tb-mainHeading] mb-1 block'>
                        Postcode
                    </label>
                    <input
                        {...register('invoiceZipcode', { required: 'Postcode is verplicht' })}
                        placeholder='Postcode'
                        type={'text'}
                        id='invoiceZipcode'
                        className='w-full'
                    />
                    <ErrorMessage
                        message={
                            typeof formState.errors.invoiceZipcode?.message === 'string'
                                ? formState.errors.invoiceZipcode?.message
                                : undefined
                        }
                    />
                </div>
            </div>

            <div className='flex flex-col space-y-1'>
                <label htmlFor='invoiceCity' className='text-sm font-medium text-[--tb-mainHeading] mb-1 block'>
                    Plaats
                </label>
                <input
                    {...register('invoiceCity', { required: 'Plaats is verplicht' })}
                    id='invoiceCity'
                    placeholder='Voorbeeldplaats'
                    type={'text'}
                    className='mb-1'
                />
                <ErrorMessage
                    message={
                        typeof formState.errors.invoiceCity?.message === 'string'
                            ? formState.errors.invoiceCity?.message
                            : undefined
                    }
                />
            </div>
        </form>
    )
}
export default Invoice3rdPartyConfirmForm
